var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [
        _vm._v(_vm._s(_vm.$ct("do-you-want-to-autofill-these-fields"))),
      ]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("app-field", {
                attrs: {
                  label: _vm.$ct("name"),
                  data: _vm.data.maatschappelijkeNaam,
                },
                model: {
                  value: _vm.selectedFields.companyName,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedFields, "companyName", $$v)
                  },
                  expression: "selectedFields.companyName",
                },
              }),
              _c("app-field", {
                attrs: { label: _vm.$ct("address"), data: _vm.data.address },
                model: {
                  value: _vm.selectedFields.address,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedFields, "address", $$v)
                  },
                  expression: "selectedFields.address",
                },
              }),
              _c("app-field", {
                attrs: { label: _vm.$ct("postal"), data: _vm.data.postal },
                model: {
                  value: _vm.selectedFields.postal,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedFields, "postal", $$v)
                  },
                  expression: "selectedFields.postal",
                },
              }),
              _c("app-field", {
                attrs: { label: _vm.$ct("city"), data: _vm.data.city },
                model: {
                  value: _vm.selectedFields.city,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedFields, "city", $$v)
                  },
                  expression: "selectedFields.city",
                },
              }),
              _c("app-field", {
                attrs: { label: _vm.$ct("tel"), data: _vm.data.tel },
                model: {
                  value: _vm.selectedFields.tel,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedFields, "tel", $$v)
                  },
                  expression: "selectedFields.tel",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }